export const CLASS_NAMES = {
  title: 'text-style-e text-neutral-900 mb-4 md:mb-10',
  checksTitle: 'text-style-g text-neutral-700 mb-4',
  listTitle: 'text-style-g text-neutral-700 mt-8 mb-4',
};

export const PROPS = {
  title: {
    text: 'Terms, Conditions & Agreement',
    className: CLASS_NAMES.title,
    skeletonProps: {
      width: 280,
    },
  },
  checksTitle: {
    text: 'Before proceeding, please be sure that you:',
    className: CLASS_NAMES.checksTitle,
    skeletonProps: {
      width: 280,
    },
  },
  checks: {
    items: [
      'Understand you are about to enter into a credit agreement, and that interest may be payable depending on the credit agreement you have chosen',
      'Can afford to pay the deposit if you have chosen to do so',
      'Understand the credit checks will be undertaken as part of the application process, which may leave a footprint on your credit history',
      'Have salary and bank details at hand',
    ],
  },
  listTitle: {
    text: 'Please confirm that:',
    className: CLASS_NAMES.listTitle,
    skeletonProps: {
      width: 100,
    },
  },
  list: {
    className: 'mb-6 md:mb-10',
    items: [
      'You are 18 or over, and a permanent UK resident able to supply UK address history for the last 3 years.',
      'You have a gross annual income each year of more than £10,000 and a bank or building society account with Direct Debit facility.',
      'You are not currently bankrupt, subject to an Individual Voluntary Agreement (IVA), or have any County Court Judgements (CCJs).',
      'I understand that the information I am about to supply will be retained on an electronic database and used in the course of considering my credit application and the management of any subsequent accounts, that you may also make checks to confirm my income or employment and that you may share personal data with selected third parties as part of the application process.',
      'I confirm that the information I have supplied in support of this credit application is true, and that I am not aware of any potential changes to my financial circumstances both at present and for the duration of the borrowing term.',
      'I understand that before I sign the loan agreement I will be provided with documentation that will outline the amount I am borrowing, the interest rate that will be charged and my monthly repayments. I understand that it is important for me to consider the above in line with my personal circumstances.',
      'I understand that upon completion of the credit application form, a search will be conducted with the credit reference agency of my credit file and that this includes the use of both public data and shared data.',
      'You accept that if you apply for and are successful in obtaining Financing the maximum warranty period in relation to installation is two years, regardless of any longer warranty period that is stated in the Quote or communicated to you by the Tradesperson. This is a condition of the Financing and the Company disclaims any liability in relation to installation after the expiry of the two-year warranty period. For the avoidance of doubt, this does not apply to any warranty period in relation to products.',
      "If your application for Finance includes the payment of a deposit, the deposit is non-refundable except in exceptional circumstances and at the Company's absolute discretion. Deposits are only payable if your application for finance is approved",
    ],
  },
};
